// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1Ec1Z","item":"PaymentsMobile_item__2t4rm","label":"PaymentsMobile_label__3OsKK","amount":"PaymentsMobile_amount__6iN8j"};